<template>
  <div class="card p-2" style="min-height: 200px">
    <div class="table-responsive">
      <table class="table">
        <thead>
        <tr>
          <th class="text-left">Requisition Title</th>
          <th class="text-center">Designation (Hiring For)</th>
          <th class="text-center">Employment Type</th>
          <th class="text-center">Department</th>
          <th class="text-center">Job Location</th>
          <th class="text-center">No. of Vacancies</th>
          <th class="text-center">Status</th>
          <th class="text-center"  v-if="isJobPost">Publish Status</th>
          <th class="text-center">Approval Remarks</th>
          <th>Action</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, i) in tableItems" :key="i">
          <td class="text-left"> {{ item.title }}</td>
          <td class="text-center"> {{ item.designation_name }}</td>
          <td class="text-center"> {{ item.employee_category_name }}</td>
          <td class="text-center"> {{ item.department_name }}</td>
          <td class="text-center"> {{ item.area_name }}</td>
          <td class="text-center"> {{ item.no_of_vacancy }}</td>
          <td class="text-center text-capitalize"> {{ item.status }}</td>
          <td class="text-center text-capitalize" v-if="isJobPost"> {{ item.publish_status }}</td>
          <td class="text-center"> {{ item.remarks }}</td>
          <td>
            <button class="btn btn-primary btn-sm me-1"
                    @click="goToEdit(item)"
                    style="cursor: pointer"
            >
              <i class="fas fa-eye"></i>
            </button>
            <button v-if="isJobPost && item.publish_status == 'publish'" class="btn btn-primary btn-sm mt-1"
                    @click="goToJobApplicationManager(item)"
                    style="cursor: pointer"
            >
              <i class="fas fa-business-time"></i>
            </button>
          </td>
        </tr>
        </tbody>
      </table>
      <p v-if="tableItems.length < 0" class="text-center mt-5">No data</p>
    </div>
  </div>
</template>

<script setup>
import {useRoute, useRouter} from "vue-router";

const props  = defineProps({
  tableItems     : Object,
  approval: {
    default: false,
    type: Boolean
  },
  isJobPost: {
    default: false,
    type: Boolean
  }
});
const route  = useRoute();
const router = useRouter();

const goToEdit = (item) => {
  let param = {
    companyId: route.params.companyId,
    moduleId: route.params.moduleId,
    menuId: route.params.menuId,
    pageId: route.params.pageId
  }

  let query = route.query;
  query.jobRequisitionId = item.id;
  query.is_approval = props.approval
  query.is_job_post = props.isJobPost

  router.push({
    name:  'job-requisition-add',
    params: param,
    query: query
  })
}

const goToJobApplicationManager = (item) => {
  let param = {
    companyId: route.params.companyId,
    moduleId: route.params.moduleId,
    menuId: route.params.menuId,
    pageId: route.params.pageId
  }

  let query = route.query;
  query.jobId = item.id;

  router.push({
    name:  'job-application-manager',
    params: param,
    query: query
  })
}
</script>
